import { SET_OWNERS } from './owners';
import { SET_ACTIVITIES } from './activities';
import { getCallConsoleItem, fetchOwners, callListUrl, CALL_LISTS_SHOW } from 'bundles/connect/helpers/prospect_api';
import { SET_INSIGHTS_PROPERTY_ID } from '../reducers/insights_property_id';

export const SET_CALL_CONSOLE_DATA = 'SET_CALL_CONSOLE_DATA';

export function setIndex(url) {
  return async (dispatch) => {
    let propertyId = '';
    await getCallConsoleItem(url).then((data) => {
      propertyId = data.insightsProperty.propertyId;
      dispatch({ type: SET_CALL_CONSOLE_DATA, payload: { activities: _, ...data } });
      dispatch({ type: SET_ACTIVITIES, payload: data.activities });
      dispatch({ type: SET_INSIGHTS_PROPERTY_ID, payload: propertyId });
      window.history.replaceState(
        {}, '', `${callListUrl(CALL_LISTS_SHOW, data.callList.id)}/call_console?index=${data.index}`
      );
    });

    return await fetchOwners(propertyId).then((data) => {
      dispatch({ type: SET_OWNERS, payload: data['connect/ownerships'] });
    }).catch(() => {
      dispatch({ type: SET_OWNERS, payload: null });
    });
  };
}
